"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MultiSelectionIsolatePage = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const styled_components_1 = __importDefault(require("styled-components"));
const templates_1 = require("../../templates");
const bridge_1 = require("@completeanatomy/bridge");
const i18n_1 = require("@completeanatomy/i18n");
const device_1 = require("@completeanatomy/device");
const ui_1 = require("@completeanatomy/ui");
const hooks_1 = require("../../hooks");
const organisms_1 = require("../../organisms");
const atoms_1 = require("../../atoms");
function MultiSelectionIsolatePage() {
    const bridge = (0, bridge_1.useBridge)();
    const { isMobile } = (0, device_1.usePlatform)();
    const { items, isExplodeActive } = (0, hooks_1.useMultiSelectState)();
    const exitIsolateMode = (0, react_1.useMemo)(() => bridge === null || bridge === void 0 ? void 0 : bridge.exitIsolateMode.bind(bridge), [bridge]);
    const toggleExplodeMode = (0, react_1.useMemo)(() => bridge === null || bridge === void 0 ? void 0 : bridge.toggleExplodeMode.bind(bridge), [bridge]);
    const onClickExplode = () => {
        toggleExplodeMode === null || toggleExplodeMode === void 0 ? void 0 : toggleExplodeMode({
            animation: true,
            exitIsolate: true,
            mode: !isExplodeActive,
        });
    };
    const handleBack = () => {
        if (isExplodeActive) {
            toggleExplodeMode === null || toggleExplodeMode === void 0 ? void 0 : toggleExplodeMode({
                animation: true,
                exitIsolate: true,
                mode: false,
            });
        }
        exitIsolateMode === null || exitIsolateMode === void 0 ? void 0 : exitIsolateMode();
    };
    const mode = isExplodeActive
        ? (0, i18n_1.Localized)(i18n_1.Strings.infoBox.isolateMode)
        : (0, i18n_1.Localized)(i18n_1.Strings.infoBox.tabs.models);
    const title = (0, i18n_1.Localized)(i18n_1.Strings.infoBox.multiSelectFocusMode);
    return ((0, jsx_runtime_1.jsxs)(templates_1.ModeTemplate, { mode: mode, title: title, onBack: handleBack, "data-e2e": 'MultiSelectionIsolatePage_ModeTemplate', children: [!isMobile && items.length > 1 && ((0, jsx_runtime_1.jsx)(ExplodeButton, { onClick: onClickExplode, iconName: isExplodeActive
                    ? ui_1.Icons.Multi_Selection_Assemble
                    : ui_1.Icons.Multi_Selection_Explode, selected: false, label: isExplodeActive
                    ? (0, i18n_1.Localized)(i18n_1.Strings.infoBox.multiSelection.assemble)
                    : (0, i18n_1.Localized)(i18n_1.Strings.infoBox.multiSelection.explode), isActive: isExplodeActive, "data-e2e": 'MultiSelectionIsolatePage_ExplodeButton' })), !isMobile && ((0, jsx_runtime_1.jsx)(organisms_1.MultiSelectionTabContent, { "data-e2e": 'MultiSelectionIsolatePage_MultiSelectionTabContent', children: items }))] }));
}
exports.MultiSelectionIsolatePage = MultiSelectionIsolatePage;
const ExplodeButton = (0, styled_components_1.default)(atoms_1.TabButton) `
  position: relative;

  left: 90px;

  fill: ${({ isActive, theme }) => isActive ? theme.text : theme.textSecondary};
`;
